(function (SSC) {
  'use strict';
  var dataEl = document.querySelector('[data-product-json]');
  if (!dataEl) return;
  var data;
  try { data = JSON.parse(dataEl.textContent); } catch (error) { return; }
  var variants = data.variants || [];
  var form = document.querySelector('[data-product-form]');
  if (!form || !variants.length) return;
  var selected = [];
  var variantInput = form.querySelector('[name="id"]');
  var price = document.querySelector('[data-product-price]');
  var compare = document.querySelector('[data-product-compare]');
  var status = document.querySelector('[data-product-status]');
  var options = document.querySelectorAll('[data-option-value]');
  var buttons = document.querySelectorAll('[data-add-direct]');
  var stickyPrice = document.querySelector('[data-sticky-price]');
  var selectedLabels = document.querySelectorAll('[data-selected-option]');

  function findVariant() {
    return variants.find(function (variant) { return variant.options.every(function (value, index) { return value === selected[index]; }); });
  }
  function isAvailable(position, value) {
    return variants.some(function (variant) {
      return variant.available && variant.options[position] === value && variant.options.every(function (option, index) { return index === position || selected[index] == null || option === selected[index]; });
    });
  }
  function render() {
    var variant = findVariant();
    options.forEach(function (option) {
      var position = Number(option.dataset.optionPosition);
      var unavailable = !isAvailable(position, option.dataset.optionValue);
      option.disabled = unavailable;
      option.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      option.setAttribute('aria-pressed', selected[position] === option.dataset.optionValue ? 'true' : 'false');
      option.classList.toggle('is-unavailable', unavailable);
    });
    buttons.forEach(function (button) {
      button.dataset.variantId = variant ? variant.id : '';
      button.disabled = !variant || !variant.available;
      button.textContent = variant && variant.available ? 'Adicionar à sacola' : (variant ? 'Esgotado' : 'Escolha as opções');
    });
    selectedLabels.forEach(function (label) {
      var position = Number(label.closest('[data-option-position]') ? label.closest('[data-option-position]').dataset.optionPosition : label.dataset.optionPosition);
      if (selected[position] != null) label.textContent = selected[position];
    });
    if (variantInput) variantInput.value = variant ? variant.id : '';
    if (price && variant) price.textContent = SSC.formatMoney(variant.price);
    if (stickyPrice && variant) stickyPrice.textContent = SSC.formatMoney(variant.price);
    if (compare) { compare.hidden = !(variant && variant.compare_at_price > variant.price); if (variant && variant.compare_at_price > variant.price) compare.textContent = SSC.formatMoney(variant.compare_at_price); }
    if (status) status.textContent = !variant ? 'Seleção incompleta' : (variant.available ? 'Disponível' : 'Esgotado');
    if (variant && variant.featured_media_id) {
      var media = document.querySelector('[data-media-id="' + variant.featured_media_id + '"]');
      if (media) media.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
    }
  }
  function initialize() {
    var fromUrl = new URL(window.location.href).searchParams.get('variant');
    var initial = variants.find(function (variant) { return String(variant.id) === String(fromUrl || data.selectedVariantId); }) || variants.find(function (variant) { return variant.available; }) || variants[0];
    selected = (initial.options || []).slice();
    render();
  }
  options.forEach(function (option) {
    option.addEventListener('click', function () {
      if (option.disabled) return;
      selected[Number(option.dataset.optionPosition)] = option.dataset.optionValue;
      render();
    });
  });
  var mainButton = document.querySelector('[data-main-add]');
  var sticky = document.querySelector('[data-product-sticky]');
  if (mainButton && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) { sticky.classList.toggle('is-visible', !entries[0].isIntersecting); }, { threshold: 0 }).observe(mainButton);
  }
  var viewedKey = 'ssc_recent_products';
  if (data.productId) {
    try {
      var recent = JSON.parse(localStorage.getItem(viewedKey) || '[]').filter(function (id) { return String(id) !== String(data.productId); });
      recent.unshift(data.productId); localStorage.setItem(viewedKey, JSON.stringify(recent.slice(0, 8)));
    } catch (error) {}
  }
  initialize();
})(window.SSC || (window.SSC = {}));
